module.exports = __webpack_public_path__ + "static/media/student-snapshort2-study.1f9b7db3.png";